export const DEFAULT_CLUSTER_COLORS = [
  { value: '#FF6B6B', label: 'Красный' },
  { value: '#4ECDC4', label: 'Бирюзовый' },
  { value: '#45B7D1', label: 'Синий' },
  { value: '#FFA07A', label: 'Лососевый' },
  { value: '#98D8C8', label: 'Мятный' },
  { value: '#F7DC6F', label: 'Жёлтый' },
  { value: '#BB8FCE', label: 'Фиолетовый' },
];

export const CLUSTER_ICON_OPTIONS = [
  { value: 'scissors', label: 'Ножницы', glyph: '✂️' },
  { value: 'tooth', label: 'Зуб', glyph: '🦷' },
  { value: 'implant', label: 'Имплант', glyph: '🔩' },
  { value: 'crown', label: 'Коронка', glyph: '👑' },
  { value: 'cleaning', label: 'Гигиена', glyph: '🪥' },
  { value: 'braces', label: 'Брекеты', glyph: '🦷' },
  { value: 'aligner', label: 'Элайнеры', glyph: '🫧' },
  { value: 'gum', label: 'Пародонт', glyph: '🩹' },
  { value: 'root-canal', label: 'Эндодонтия', glyph: '🪡' },
  { value: 'filling', label: 'Реставрация', glyph: '🧩' },
  { value: 'heart', label: 'Сердце', glyph: '❤️' },
  { value: 'syringe', label: 'Шприц', glyph: '💉' },
  { value: 'stethoscope', label: 'Стетоскоп', glyph: '🩺' },
  { value: 'pill', label: 'Таблетка', glyph: '💊' },
  { value: 'bandage', label: 'Бинт', glyph: '🩹' },
];

const CLUSTER_ICON_MAP = Object.fromEntries(
  CLUSTER_ICON_OPTIONS.map((option) => [option.value, option.glyph])
);

export function getClusterColor(color?: string, fallbackIndex = 0): string {
  if (color) {
    return color;
  }

  return DEFAULT_CLUSTER_COLORS[fallbackIndex % DEFAULT_CLUSTER_COLORS.length].value;
}

export function getClusterIconGlyph(icon?: string): string {
  if (!icon) {
    return '📦';
  }

  return CLUSTER_ICON_MAP[icon] || icon;
}
